import React from 'react';
import { useLanguageStore } from "../store/languageStore";

export default function AboutUsSection() {
    const { language } = useLanguageStore();

    const isArabic = language === 'ar';

    const content = {
        title: isArabic ? "من نحن" : "About Us",
        description: isArabic
            ?" نحن شركة رائدة في قطاع البناء، متخصصون في تقديم حلول متكاملة تشمل المقاولات، التنفيذ، تصنيع كيماويات البناء المُتخصصة (من لواصق البلاط، مواد الإنهاءات الأسمنتية والجِبسية، الطلاءات العازلة والديكورية، والمضافات الخرسانية، ... )"
            : "We are a leading construction company offering integrated solutions, including contracting, execution, and manufacturing of specialized building chemicals (e.g., tile adhesives, cement, gypsum finishes, waterproofing, decorative coatings, and concrete additives). We leverage innovative technologies like Nano Gel to enhance material performance,",
        certifications: isArabic
            ? "مدعومة بفريق بحث وتطوير مخصص وشهادات عالمية مثل ISO 9001 وISO 14001 وغيرها."
            : "Backed By A Dedicated R&D Team And Global Certifications ISO 9001 And ISO 14001, Etc..",
        vision: isArabic ? "رؤيتنا" : "OUR VISION",
        visionText: isArabic
            ? "أن نكون روادًا في تطوير قطاع البناء عبر تغيير المفاهيم التقليدية ورفد السوق بمنتجات عالية الجودة تُطيل العمر الافتراضي للمنشآت. حيث نسعى لإنشاء مباني تحافظ على جودتها واعتماديتها لعقود، مع الحفاظ على البيئة عبر حلول مستدامة.   "
            : " To pioneer the transformation of the construction sector by redefining traditional practices and delivering high-quality products that extend infrastructure lifespan. We aim to create buildings that maintain their quality and reliability for decades, while promoting sustainability.",
        message: isArabic ? "رسالتنا" : "OUR MESSAGE",
        messageText: isArabic
            ? "نقدم حلولاً ذكيةً وصديقةً للبيئة تُحقق رضاكم وثقتكم، عبر دمج الابتكار مع الخبرة الفنية، لضمان مستقبل بناءٍ أكثر استقرارًا وفعّالية."
            : "We provide smart, eco-friendly solutions that ensure your satisfaction and trust, combining innovation with technical expertise to build a more resilient and efficient future.",
        innovationTitle: isArabic
            ? "ابتكار ثوري في مواد البناء"
            : "A REVOLUTIONARY INNOVATION IN CONSTRUCTION MATERIALS",
        nanoTitle: isArabic ? "تقنية النانو جيل" : "NANO GEL TECHNOLOGY",
        nanoText: isArabic
            ? "تُعد تقنية النانو جيل إحدى ابتكاراتنا المصممة لتعزيز أداء مواد البناء من خلال دمج جزيئات نانوية فائقة الصغر..."
            : "Nano - Gel Technology One Of Our Many Innovations, Designed To Enhance The Performance Of Building Materials...",
        howItWorks: isArabic ? "كيف تعمل؟" : "HOW DOES IT WORK?",
        howItWorksItems: [
            {
                title: isArabic ? "تعزيز الالتصاق" : "ENHANCED BONDING",
                text: isArabic
                    ? "تملأ الجزيئات النانوية المسام المجهرية على الأسطح مما يحسن بشكل كبير من قوة الالتصاق..."
                    : "Nanoparticles Fill Microscopic Pores On Surfaces, Significantly Improving Adhesion Strength...",
            },
            {
                title: isArabic ? "مرونة فائقة" : "SUPERIOR FLEXIBILITY",
                text: isArabic
                    ? "تحتفظ المواد المعززة بالنانو بمرونتها تحت الظروف القاسية، مما يقلل من التشققات."
                    : "Nano-Enhanced Materials Retain Flexibility Under Harsh Conditions...",
            },
            {
                title: isArabic ? "مقاومة للعوامل الخارجية" : "RESISTANCE TO EXTERNAL FACTORS",
                text: isArabic
                    ? "تشكل حاجزاً كثيفاً ضد الرطوبة وأشعة الشمس والتآكل الكيميائي."
                    : "Creates Ultra-Dense Barrier Against Moisture, UV Rays, And Chemical Corrosion.",
            },
        ],
        benefitsTitle: isArabic ? "فوائد تقنية النانو جيل" : "BENEFITS OF NANO GEL TECHNOLOGY",
        benefits: [
            {
                title: isArabic ? "عمر افتراضي طويل " : "Extended Lifespan",
                desc: isArabic
                    ? "مثالية للمشاريع التي تتطلب متانة لعقود."
                    : "Ideal For Projects Requiring Decades-Long Durability.",
            },
            {
                title: isArabic ? "كفاءة اقتصادية " : "Cost Efficiency",
                desc: isArabic
                    ? "تقلل الحاجة إلى الصيانة المتكررة."
                    : "Reduces The Need For Frequent Maintenance.",
            },
            {
                title: isArabic ? "صديقة للبيئة " : "Eco-Friendly",
                desc: isArabic
                    ? "تقليل استهلاك المواد بفضل الكفاءة العالية."
                    : "Lower Material Consumption Due To High Efficiency.",
            },
        ]
    };

    return (
        <div className="w-full" dir={isArabic ? "rtl" : "ltr"}>
            {/* Header Image */}
            <div className="w-full h-80 bg-gray-900 relative overflow-hidden">
                <img loading="lazy"
                    src={require('../assest/about/1.png')}
                    alt="Header"
                    className="w-full h-full object-cover opacity-90"
                />
            </div>

            {/* Content */}
            <div className="w-full bg-gray-100 py-16">
                <div className="container mx-auto px-6">
                    <h2 className="text-4xl font-light text-center text-teal-500 mb-10">{content.title}</h2>

                    <div className="max-w-4xl mx-auto mb-12">
                        <p className="text-gray-700 text-lg leading-relaxed text-center">
                            {content.description}
                        </p>
                    </div>

                    <div className="max-w-3xl mx-auto mb-20">
                        <p className="text-gray-600 text-center text-sm">
                            {content.certifications}
                        </p>
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-16">
                        <div className="bg-gray-200 p-10">
                            <h3 className="text-teal-500 uppercase font-medium mb-6">{content.vision}</h3>
                            <p className="text-gray-700 leading-relaxed">{content.visionText}</p>
                        </div>

                        <div className="h-full">
                            <img loading="lazy"
                                src={require('../assest/about/2.png')}
                                alt="Team"
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Message */}
            <div className="max-w-6xl mx-auto px-4 py-8 ">
                <div className="w-full mb-12">
                    <img loading="lazy"
                        src={require('../assest/about/3.png')}
                        alt="Building"
                        className="w-full h-96 object-cover rounded"
                    />
                </div>

                <div className="bg-gray-100 p-8 mb-20 rounded">
                    <h2 className="text-green-400 text-lg mb-4">{content.message}</h2>
                    <p className="text-gray-800 text-xl font-medium leading-relaxed">{content.messageText}</p>
                </div>

                {/* Innovation */}
                <div className="mb-20">
                    <h2 className="text-center text-3xl font-bold mb-16 text-gray-800">
                        {content.innovationTitle}
                    </h2>

                    <div className="flex flex-col md:flex-row gap-10 mb-20">
                        <div className="md:w-1/4">
                            <h3 className="text-green-400 text-xl font-medium">{content.nanoTitle}</h3>
                        </div>
                        <div className="md:w-3/4">
                            <p className="text-gray-700 leading-relaxed">{content.nanoText}</p>
                        </div>
                    </div>
                </div>

                {/* How it works */}
                <div className="mb-20">
                    <div className="w-full mb-16">
                        <img loading="lazy"
                            src={require('../assest/about/4.jpeg')}
                            alt="Adhesive"
                            className="w-full object-cover rounded-lg"
                        />
                    </div>

                    <h2 className="text-green-400 text-xl mb-16">{content.howItWorks}</h2>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
                        {content.howItWorksItems.map((item, index) => (
                            <div key={index}>
                                <h3 className="font-bold text-lg mb-4">{item.title}</h3>
                                <p className="text-gray-700">{item.text}</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Benefits */}
                <div className="bg-gray-100 p-8 mb-20 rounded">
                    <h2 className="font-bold text-xl mb-8">{content.benefitsTitle}</h2>

                    <ul className="space-y-4">
                        {content.benefits.map((b, i) => (
                            <li className="flex" key={i}>
                                <span className="mr-2">•</span>
                                <div>
                                    <span className="font-bold">{b.title}</span>
                                    <span className="ml-2 text-gray-700">{b.desc}</span>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Logos */}
                <div className="mb-20">
                    <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12">
                        {[1, 2, 3, 4, 5].map((num) => (
                            <div className="flex flex-col items-center w-32" key={num}>
                                <div className="bg-white p-2 rounded-full">
                                    <div className="w-16 h-16 flex items-center justify-center">
                                        <img loading="lazy"
                                            src={require(`../assest/about/logo/${num}.png`)}
                                            alt={`Logo ${num}`}
                                            className="w-full"
                                        />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
